/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AllocateLineDto,
  CreateSourcingBatchesDto,
  CreateSourcingBatchesResponseDto,
  RecordSupplierResponseDto,
  SupplierBatchDto,
  SupplierBatchListResponseDto,
} from '../models/index';
import {
    AllocateLineDtoFromJSON,
    AllocateLineDtoToJSON,
    CreateSourcingBatchesDtoFromJSON,
    CreateSourcingBatchesDtoToJSON,
    CreateSourcingBatchesResponseDtoFromJSON,
    CreateSourcingBatchesResponseDtoToJSON,
    RecordSupplierResponseDtoFromJSON,
    RecordSupplierResponseDtoToJSON,
    SupplierBatchDtoFromJSON,
    SupplierBatchDtoToJSON,
    SupplierBatchListResponseDtoFromJSON,
    SupplierBatchListResponseDtoToJSON,
} from '../models/index';

export interface AllocateLineRequest {
    id: string;
    lineId: string;
    allocateLineDto: AllocateLineDto;
}

export interface CreateBatchesRequest {
    createSourcingBatchesDto: CreateSourcingBatchesDto;
}

export interface DeleteBatchRequest {
    id: string;
}

export interface GetBatchByIdRequest {
    id: string;
}

export interface GetBatchesRequest {
    status?: GetBatchesStatusEnum;
    supplierId?: number;
    periodFrom?: string;
    periodTo?: string;
    page?: number;
    pageSize?: number;
}

export interface PropagateBatchRequest {
    id: string;
}

export interface RecordSupplierResponseRequest {
    id: string;
    recordSupplierResponseDto: RecordSupplierResponseDto;
}

export interface SendBatchRequest {
    id: string;
}

/**
 * 
 */
export class SourcingServiceApi extends runtime.BaseAPI {

    /**
     * Allocate a shortage line across its linked orderItems
     */
    async allocateLineRaw(requestParameters: AllocateLineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierBatchDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling allocateLine().'
            );
        }

        if (requestParameters['lineId'] == null) {
            throw new runtime.RequiredError(
                'lineId',
                'Required parameter "lineId" was null or undefined when calling allocateLine().'
            );
        }

        if (requestParameters['allocateLineDto'] == null) {
            throw new runtime.RequiredError(
                'allocateLineDto',
                'Required parameter "allocateLineDto" was null or undefined when calling allocateLine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sourcing/batch/{id}/lines/{lineId}/allocate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"lineId"}}`, encodeURIComponent(String(requestParameters['lineId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AllocateLineDtoToJSON(requestParameters['allocateLineDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierBatchDtoFromJSON(jsonValue));
    }

    /**
     * Allocate a shortage line across its linked orderItems
     */
    async allocateLine(requestParameters: AllocateLineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierBatchDto> {
        const response = await this.allocateLineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create sourcing batches from selected orders, one per distinct supplier
     */
    async createBatchesRaw(requestParameters: CreateBatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSourcingBatchesResponseDto>> {
        if (requestParameters['createSourcingBatchesDto'] == null) {
            throw new runtime.RequiredError(
                'createSourcingBatchesDto',
                'Required parameter "createSourcingBatchesDto" was null or undefined when calling createBatches().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sourcing/batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSourcingBatchesDtoToJSON(requestParameters['createSourcingBatchesDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSourcingBatchesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create sourcing batches from selected orders, one per distinct supplier
     */
    async createBatches(requestParameters: CreateBatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSourcingBatchesResponseDto> {
        const response = await this.createBatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Discard a PENDING_REVIEW batch and revert affected orderItems
     */
    async deleteBatchRaw(requestParameters: DeleteBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sourcing/batch/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Discard a PENDING_REVIEW batch and revert affected orderItems
     */
    async deleteBatch(requestParameters: DeleteBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBatchRaw(requestParameters, initOverrides);
    }

    /**
     * Get a sourcing batch with aggregated lines + allocations
     */
    async getBatchByIdRaw(requestParameters: GetBatchByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierBatchDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getBatchById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sourcing/batch/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierBatchDtoFromJSON(jsonValue));
    }

    /**
     * Get a sourcing batch with aggregated lines + allocations
     */
    async getBatchById(requestParameters: GetBatchByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierBatchDto> {
        const response = await this.getBatchByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List sourcing batches (paginated, filterable)
     */
    async getBatchesRaw(requestParameters: GetBatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierBatchListResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['supplierId'] != null) {
            queryParameters['supplierId'] = requestParameters['supplierId'];
        }

        if (requestParameters['periodFrom'] != null) {
            queryParameters['periodFrom'] = requestParameters['periodFrom'];
        }

        if (requestParameters['periodTo'] != null) {
            queryParameters['periodTo'] = requestParameters['periodTo'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sourcing/batch`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierBatchListResponseDtoFromJSON(jsonValue));
    }

    /**
     * List sourcing batches (paginated, filterable)
     */
    async getBatches(requestParameters: GetBatchesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierBatchListResponseDto> {
        const response = await this.getBatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Propagate batch decisions to its orders. Sets retailerConfirmationStatus=PENDING for affected orders; transitions unaffected orders to PROCESSING.
     */
    async propagateBatchRaw(requestParameters: PropagateBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierBatchDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling propagateBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sourcing/batch/{id}/propagate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierBatchDtoFromJSON(jsonValue));
    }

    /**
     * Propagate batch decisions to its orders. Sets retailerConfirmationStatus=PENDING for affected orders; transitions unaffected orders to PROCESSING.
     */
    async propagateBatch(requestParameters: PropagateBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierBatchDto> {
        const response = await this.propagateBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Record supplier responses for one or more lines (confirmed qty/price/unavailable/notes)
     */
    async recordSupplierResponseRaw(requestParameters: RecordSupplierResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierBatchDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling recordSupplierResponse().'
            );
        }

        if (requestParameters['recordSupplierResponseDto'] == null) {
            throw new runtime.RequiredError(
                'recordSupplierResponseDto',
                'Required parameter "recordSupplierResponseDto" was null or undefined when calling recordSupplierResponse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sourcing/batch/{id}/lines`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RecordSupplierResponseDtoToJSON(requestParameters['recordSupplierResponseDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierBatchDtoFromJSON(jsonValue));
    }

    /**
     * Record supplier responses for one or more lines (confirmed qty/price/unavailable/notes)
     */
    async recordSupplierResponse(requestParameters: RecordSupplierResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierBatchDto> {
        const response = await this.recordSupplierResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark batch as sent to supplier (PENDING_REVIEW → SENT_TO_SUPPLIER)
     */
    async sendBatchRaw(requestParameters: SendBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierBatchDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling sendBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sourcing/batch/{id}/send`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierBatchDtoFromJSON(jsonValue));
    }

    /**
     * Mark batch as sent to supplier (PENDING_REVIEW → SENT_TO_SUPPLIER)
     */
    async sendBatch(requestParameters: SendBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierBatchDto> {
        const response = await this.sendBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetBatchesStatusEnum = {
    PendingReview: 'PENDING_REVIEW',
    SentToSupplier: 'SENT_TO_SUPPLIER',
    SupplierResponded: 'SUPPLIER_RESPONDED',
    ChangesPropagated: 'CHANGES_PROPAGATED',
    Completed: 'COMPLETED'
} as const;
export type GetBatchesStatusEnum = typeof GetBatchesStatusEnum[keyof typeof GetBatchesStatusEnum];
